import { Modal, Button, Spin } from 'antd';
import { GoToStoreOutlineSVG } from 'components/iconsSVG/goToStoreOutline';
import { CloseModalSVG } from 'components/iconsSVG/close';
import { useEffect, useMemo, useState } from 'react';
import MapComponent from 'components/map';
import { useI18n } from 'context/i18n';
import useSWRImmutable from 'swr/immutable';

import { getAllStores } from 'actions/shops';
import styles from './styles.module.css';

function calculateAverage(storesArray) {
  return storesArray
    .reduce(
      ([ lat, long ], store) => {
        const newCoords = [ lat + store.latitude, long + store.longitude ];
        return newCoords;
      },
      [ 0, 0 ],
    )
    .map((n) => n / storesArray.length);
}

export function StoresModal() {
  const { t, locale } = useI18n();
  const [ open, setOpen ] = useState();
  const [ options, setOptions ] = useState({ type: 'repair', title: '' });
  const { data, isLoading } = useSWRImmutable(open ? `/stores?type=${options.type}` : null, async () => getAllStores({ profile: locale, repairProgram: options.type === 'repair' }));

  const [ view, setView ] = useState('list'); // map | stores
  const [ selectedStore, setSelectedStore ] = useState(null);
  const filteredStores = useMemo(() => data ?? [], [ data ]);

  useEffect(() => {
    window.showStoreLocator = function ({ type, title } = { type: 'repair', title: '' }) {
      setOptions({ type, title });
      setOpen(true);
    };
    return () => {
      window.showStoreLocator = undefined;
    };
  }, []);

  const handleClickMarker = (coords) => {
    const foundStore = filteredStores.find((s) => s.latitude === coords[0] && s.longitude === coords[1]);
    if (foundStore) {
      setSelectedStore(foundStore);
      setView('list');

      setTimeout(() => {
        const foundDiv = document.querySelector(`[data-store="${foundStore.id}"]`);
        const foundList = document.getElementById('modalStoresList');
        if (foundDiv && foundList) {
          const { top, height } = foundDiv.getBoundingClientRect();
          foundList.scrollBy({ top: top - height - 30, behavior: 'smooth' });
        }
      }, 500);
    }
  };

  const MapMemo = useMemo(() => (
    <MapComponent
      sticky={false}
      center={!filteredStores.length ? [ 0, 0 ] : selectedStore === null ? calculateAverage(filteredStores) : [ selectedStore.latitude, selectedStore.longitude ]}
      visible={true}
      viewStoreInMap={false}
      pins={filteredStores.map(({ latitude, longitude }) => ({
        latitude, longitude,
      }))}
      onClickMarker={handleClickMarker}
      markerProvider={{ iconUrl: '/assets-new/nn-locator-marker.svg', iconSize: [ 21, 32 ] }}
      selectedMarkerProvider={{ iconUrl: '/assets-new/nn-locator-marker-selected.svg', iconSize: [ 21, 32 ] }}
      zoom={selectedStore ? 12 : 5}
    />
  ), [ filteredStores, selectedStore ]);

  return (
    <Modal
    width={800}
      visible={open}
      centered={true}
      closable={true}
      onCancel={() => setOpen(false)}
      footer={null}
      closeIcon={<CloseModalSVG/>}
    >
      <div className={styles.container}>
        <div className={styles.dispoStoresContainer}>
          <p className={styles.title}>{options.title}</p>
          <div className={styles.content}>
            {isLoading ? <div className={styles.spin}><Spin size='large' /></div> : null}
            {!isLoading && view === 'map' ? <div data-view={view} className={styles.mapContainer}>{MapMemo}</div> : null}
            {!isLoading && view === 'list' ? (
              <div id="modalStoresList" data-view={view} className={styles.list}>
                  {data?.map((store) => (
                    <div key={`store-${store.id}`} className={styles.listItem} data-store={store.id} data-active={selectedStore && selectedStore.id === store.id}>
                      <p className={styles.storeName}>
                        <img src='/assets-new/no_trace_program/nn-minilogo.png' alt="nnormal logo" width={21} />
                        <span>{store.name}</span>
                      </p>
                      <div className={styles.storeAddress}>
                        <p>{store.address1}</p>
                        <p>{store.postalCode}, {store.cityName}</p>
                        <p>{store.telephone}</p>
                      </div>
                      <button className={styles.viewInMap} rel="noreferrer" onClick={() => { setSelectedStore(store); setView('map'); }}>
                        {t('tiendas.locator', 'view.in.map', 'View in map')}
                      </button>
                      <a href={store.urlGoogleMaps || `https://maps.google.com/?q=${store.latitude},${store.longitude}`} target="_blank" className={styles.viewInGoogle} rel="noreferrer">
                        <GoToStoreOutlineSVG />
                        <span>{t('generico', 'go.to.store', 'GO TO STORE')}</span>
                      </a>
                    </div>
                  ))}
              </div>
            ) : null}
          </div>
        </div>
        <div className={styles.buttonContainer}>
          { view === 'map' ? (
            <Button type="primary" className={styles.changeTabBtn} onClick={() => setView('list')}>
              {t('generico', 'view.list', 'View List')}
            </Button>
          ) : (
            <Button type="primary" className={styles.changeTabBtn} onClick={() => {
              setSelectedStore(null);
              setView('map');
            }}>
              {t('generico', 'view.map', 'View Map')}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
}
